import type { LessonDraft, ValidationResult } from "../../shared/schema";
async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`/api/${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...init?.headers,
    },
  });
  const body = (await response.json()) as { data?: T; error?: string };
  if (!response.ok || !body.data) throw new Error(body.error || "後台服務暫時無法使用");
  return body.data;
}

export interface LearningTree {
  stages: Array<{
    id: string;
    key: string;
    title: string;
    units: Array<{
      id: string;
      key: string;
      title: string;
      lessons: Array<{ id: string; key: string; title: string; cardCount: number }>;
    }>;
  }>;
}

export interface ReleaseSummary {
  id: string;
  version: string;
  itemCount: number;
  reviewState: string;
  createdAt: string;
}

export const api = {
  me: () => request<{ id: string; email: string; roles: string[] }>("me"),
  dashboard: () => request<{ pilot?: string; stable?: string; lessonCount: number; draftCount: number }>("dashboard"),
  releases: () => request<ReleaseSummary[]>("releases"),
  tree: () => request<LearningTree>("learning/tree"),
  draft: (lessonKey: string) => request<LessonDraft>(`lessons/${encodeURIComponent(lessonKey)}/draft`),
  saveDraft: (draft: LessonDraft) =>
    request<LessonDraft>(`lessons/${encodeURIComponent(draft.lessonKey)}/draft`, {
      method: "PUT",
      body: JSON.stringify({ expectedVersion: draft.editVersion, draft }),
    }),
  validate: (draft: LessonDraft) =>
    request<ValidationResult>(`lessons/${encodeURIComponent(draft.lessonKey)}/validate`, {
      method: "POST",
      body: JSON.stringify({ draft }),
    }),
  publishPilot: (lessonKey: string) =>
    request<{ version: string; releaseId: string }>(`lessons/${encodeURIComponent(lessonKey)}/publish-pilot`, { method: "POST", body: "{}" }),
  promote: (releaseId: string) => request<{ version: string }>("releases/promote", { method: "POST", body: JSON.stringify({ releaseId }) }),
  rollback: (channel: "pilot" | "stable", releaseId: string) => request<{ channel: string; version: string }>("channels/rollback", { method: "POST", body: JSON.stringify({ channel, releaseId }) }),
};
